<script>
import _unionWith from 'lodash/unionWith'
import _isEmpty from 'lodash/isEmpty'
import _sortBy from 'lodash/sortBy'

import Layout from '@layouts/main'
import ProductItem from '@components/ProductItem'
import SelectBookingDateSize from '@components/SelectBookingDateSize'
import BookingBanner from '@components/BookingBanner'
import parseStringToDate from '@utils/parse-string-to-date'
import formatDate from '@utils/format-date'

import addDays from 'date-fns/addDays'
import getYear from 'date-fns/getYear'
import getMonth from 'date-fns/getMonth'

export default {
  page() {
    return {
      title: this.merchant.name,
    }
  },
  components: {
    Layout,
    ProductItem,
    SelectBookingDateSize,
    BookingBanner,
  },
  props: {
    merchant: {
      type: Object,
      required: true,
    },
    products: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showIntro: false,
      selectedValue: {
        date: new Date(),
        groupSize: 1,
        timeSession: 'all',
      },
      tabsIndex: {
        timeSession: 0,
      },
      maxGroupSize: 20,
      timeSessionData: Object.freeze({
        all: this.$t('global.ALL_DAY' /* 整天 */),
        morning: this.$t('global.MORNING' /* 上午 */),
        afternoon: this.$t('global.AFTERNOON' /* 下午 */),
        night: this.$t('global.EVENING' /* 晚上 */),
      }),
      loadedTimeSessionsData: {},
      loadedDateTimesData: {},
      loadingDateTimesData: {},
      loadedDateTimesDataGroup: []
    }
  },

  computed: {
    availableSessions() {
      const allProductSession = _unionWith(
        ...Object.values(this.loadedTimeSessionsData)
      );

      return ['all', ...allProductSession]
    },
    availableDates() {

      const loadedDateTimesData = this.loadedDateTimesData[this.selectedValue.groupSize] || [];
      // omit date from product
      const onlyDatesArrays = Object.values(loadedDateTimesData).map(
        (product) => {
          return product.map((dateTimes) => dateTimes.date)
        }
      );

      // union date arrays without empty array
      const unionedArrays = _unionWith(...onlyDatesArrays, _isEmpty).map(
        (date) => parseStringToDate(date)
      );

      return _sortBy(unionedArrays)
    },
    noProducts() {
      return this.products.length === 0
    },
  },
  watch: {
    availableDates: 'updateDefaultSelectedDate',
    'selectedValue.groupSize': 'changeSelectedGropSize',
  },
  mounted() {
    this.products.forEach( ({ alias }) => {
      this.$set(this.loadingDateTimesData, alias, true);
    });
    this.getCapacityOfProducts();
    this.$store.dispatch('booking/updateCart');
  },
  methods: {
    updateDefaultSelectedDate() {
      // ensure availableDates is not empty would causing errors
      if (this.availableDates.length > 0) {
        const selectedDate = this.selectedValue.date; // default: today UTC

        const selectedIsAvailable = this.availableDates.filter((item) => {
          return formatDate(item) === formatDate(selectedDate)
        });

        if (selectedIsAvailable.length === 0) {
          const [firstAvailableDate] = this.availableDates; // UTC
          this.selectedValue = {
            ...this.selectedValue,
            date: firstAvailableDate,
          }
        }
      }
    },
    updateProductTimeSessions({ productKey, sessionArray }) {
      this.$set(this.loadedTimeSessionsData, productKey, sessionArray)
    },
    /* async getCapacityOfProducts() {
      this.products.forEach(async ({ alias }) => {
        this.$set(this.loadedDateTimesData, alias, []);
        this.$set(this.loadingDateTimesData, alias, true);

        await this.$store
          .dispatch('merchant/fetchProductCapacity', {
            merchantAlias: this.merchant.alias,
            productAlias: alias,
            groupSize: this.selectedValue.groupSize,
          })
          .then((response) => {
            this.$set(this.loadingDateTimesData, alias, false);
            this.$set(this.loadedDateTimesData, alias, response)
          })
      })
    }, */
    handleToBookingStep0({ product, selectedTime }) {
      this.$store.dispatch('booking/updateCart', {
        ...this.selectedValue,
        time: selectedTime,
        params: {},
        product,
      });

      this.$router.push({
        name: 'booking-product',
        params: { productId: product.alias },
        query: {
          language: this.$route.query.language,
        },
      })
    },
    /*
    * 變更人數
    * */
    changeSelectedGropSize() {
      const month = getMonth(this.selectedValue.date) + 1;
      const year = getYear(this.selectedValue.date);

      this.getCapacityOfProducts(year, month)
    },
    /*
    * 取得活動可用時段
    * */
    async getCapacityOfProducts(year = new Date().getFullYear(), month = new Date().getMonth() + 1) {
      const formatMonth = Number(month) < 10 ? `0${Number(month)}` : month;
      const monthLast = formatDate(addDays(new Date(year, month, 1), -1));
      const groupSize = this.selectedValue.groupSize;

      const isExpiredDate = new Date().getTime() - new Date(year, month - 1, 1).getTime() > 0;
      const isExpiredMonth = new Date().getFullYear() >= year && new Date().getMonth() + 1 > month;

      const date = isExpiredDate ? new Date().getDate() : '01';
      const fmDate = Number(date) < 10 ? `0${Number(date)}` : date;

      if(isExpiredMonth) {
        this.$set(this.loadedDateTimesData, groupSize, {});

        this.products.forEach( ({ alias }) => {
          this.$set(this.loadedDateTimesData.groupSize, alias , []);
        })
      }

      this.products.forEach(async ({ alias }) => {
        if(isExpiredMonth || this.loadedDateTimesDataGroup.includes(`${year}-${formatMonth}&groupSize:${groupSize}&alias:${alias}`)) {
          this.$set(this.loadedDateTimesData, alias, false);
        } else {
          await this.$store
            .dispatch('merchant/fetchProductCapacity', {
              merchantAlias: this.merchant.alias,
              productAlias: alias,
              groupSize: groupSize,
              startDate: `${year}-${formatMonth}-${fmDate}`,
              endDate: monthLast
            })
            .then((dateTimes) => {
              this.loadedDateTimesDataGroup.push(`${year}-${formatMonth}&groupSize:${groupSize}&alias:${alias}`);
              this.$set(this.loadingDateTimesData, alias, false);

              if(!this.loadedDateTimesData[groupSize]) {
                this.$set(this.loadedDateTimesData, groupSize, {});
              }

              if(!this.loadedDateTimesData[groupSize][alias]) {
                this.$set(this.loadedDateTimesData[groupSize], alias, []);
                this.$set(this.loadedDateTimesData[groupSize], alias, dateTimes);
              }else {
                dateTimes.forEach(item => {
                  this.loadedDateTimesData[groupSize][alias].push(item);
                })
              }
            })
        }
      })

    },
    getLoadedDateTimesData(alias) {
      const groupSize = this.loadedDateTimesData[this.selectedValue.groupSize] || {};

      return groupSize[alias] || [];
    },
    handleDateIsChanged() {

    },
    /*
    * 切換日期選擇器年月
    * */
    handlePageIsChanged(page) {
      const year = page.year;
      const month = page.month;

      this.getCapacityOfProducts(year, month)
    },
  },
}
</script>

<template>
  <Layout>
    <div class="booking-container">
      <BookingBanner :merchant="merchant"></BookingBanner>
      <template v-if="!noProducts">
        <div class="booking-section">
          <div class="subsection">
            <div class="subsection__title">{{ $t('global.DATE_AND_GROUP_SIZE'/*預訂日期與人數*/) }}</div>
            <SelectBookingDateSize
              :date.sync="selectedValue.date"
              :size.sync="selectedValue.groupSize"
              :available-dates="availableDates"
              :max-size="maxGroupSize"
              @select-date="handleDateIsChanged"
              @change-page="handlePageIsChanged"
            />
          </div>
        </div>
        <div class="booking-section">
          <div class="level subsection is-tab-style">
            <h4
              class="level-left booking-section__title"
            >{{ $t('global.SELECT_RESERVATION_TIME'/*選擇預訂時段*/) }}</h4>
            <div v-if="!noProducts" class="level-right buttons is-tab-style">
              <button
                v-for="session in availableSessions"
                :key="session"
                class="button is-tab-style"
                :class="{ 'is-active': selectedValue.timeSession === session }"
                @click="selectedValue.timeSession = session"
              >{{ timeSessionData[session] }}</button>
            </div>
          </div>
          <div class="subsection product-wrapper">
            <ProductItem
              v-for="product in products"
              ref="product"
              :key="product.alias"
              :data="product"
              :date-times="getLoadedDateTimesData(product.alias)"
              :date-loading="loadingDateTimesData[product.alias]"
              :select-date="selectedValue.date"
              :select-time-session="selectedValue.timeSession"
              @select-time="handleToBookingStep0"
              @update-sessions="updateProductTimeSessions"
            />
          </div>
        </div>
      </template>
      <template v-else>
        <div class="defaultBox">
          <img :alt="$t('global.NULL_MERCHANT_EVENT'/*商家無任何商品*/)"
               class="defaultBox__image"
               src="@assets/images/information_default.png" />
          <h3 class="defaultBox__text">
            {{ $t('global.NULL_MERCHANT_EVENT'/*商家無任何商品*/) }}
          </h3>
        </div>
      </template>
    </div>
  </Layout>
</template>
<style lang="scss" module>
.summaryItem {
  margin-bottom: 1rem;
}
.summaryTitle {
  margin-bottom: 0.25rem;
  font-size: 16px;
  color: #777;
  letter-spacing: 1px;
  text-transform: capitalize;
}
.summaryDes {
  font-size: 18px;
  font-weight: 500;
  line-height: 1.83;
  color: #575c5c;
  letter-spacing: 1px;
}
</style>
